import { IPanelFilterWidget } from '../models/panel-filter-widget-model';

export class  PanelFilterWidgetService {

    constructor(public host?: string, public language?: string) {}

    public getPanelFilterWidget = (codename: string, HttpService: any) : Promise<IPanelFilterWidget> => {
        return this.getPanelFilterWidgetData(this.getPanelFilterWidgetQuery(codename), HttpService);
    }

    private getPanelFilterWidgetData = (url: string, HttpService: any): Promise<IPanelFilterWidget> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IPanelFilterWidget) => {
                resolve(result);
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getApiBaseUrl(): string { 
        return `${this.host || ""}/api/panelfilterwidget/panelfilterwidgets/${this.language || 'nl'}`;
    }

    private getPanelFilterWidgetQuery = (codename: string): string => {
        return `${this.getApiBaseUrl()}/${codename}`
    }
}
